export default __webpack_public_path__ + "static/sanjayRakesh7-3eda15084fc42c22e42ce760830ed832.jpg";